import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import VpsService from '../../services/VpsService'
import {
  openErrorNotification,
  openSuccessNotification,
} from '../../utils/openNotification'
import i18n from '../../lang'
import ReverseProxyService from '../../services/ReverseProxyService'

export const initialState = {
  isLoadingVps: false,
  isLoadingReverseProxy: false,
  isLoadingEditProxy: false,
  isLoadingRoutes: false,
  isLoadingAddRoute: false,
  isLoadingEditRoute: false,
  isLoadingDeleteReverseProxy: false,
  isLoadingReverseProxyList: false,
  vps: [],
  routes: { list: [], page: 1 },
  services: { list: [], page: 1 },
  reverseProxyList: { list: [], page: 1 },
  reverseProxy: null,
}

export const getReverseProxyList = createAsyncThunk(
  'reverseProxy/getReverseProxyList',
  async ({ page, limit = 10 }, { rejectWithValue }) => {
    try {
      return await ReverseProxyService.getReverseProxyList({ page, limit })
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const deleteReverseProxy = createAsyncThunk(
  'reverseProxy/deleteReverseProxy',
  async ({ id, page, limit }, { rejectWithValue, dispatch }) => {
    try {
      const response = await ReverseProxyService.deleteReverseProxy(id)

      await dispatch(getReverseProxyList({ page, limit }))

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getListVps = createAsyncThunk(
  'reverseProxy/getListVps',
  async (_, { rejectWithValue }) => {
    try {
      return await VpsService.listVps()
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getReverseProxy = createAsyncThunk(
  'reverseProxy/getReverseProxy',
  async (id, { rejectWithValue }) => {
    try {
      return await ReverseProxyService.getReverseProxy(id)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const createReverseProxy = createAsyncThunk(
  'reverseProxy/createReverseProxy',
  async (data, { rejectWithValue }) => {
    try {
      return await ReverseProxyService.createReverseProxy(data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const updateReverseProxy = createAsyncThunk(
  'reverseProxy/updateReverseProxy',
  async ({ id, ...data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await ReverseProxyService.updateReverseProxy(id, data)

      await dispatch(getReverseProxy(id))

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getRoutes = createAsyncThunk(
  'reverseProxy/getRoutes',
  async (reverseProxyId, { rejectWithValue }) => {
    try {
      return await ReverseProxyService.getRoutes(reverseProxyId)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const addRoute = createAsyncThunk(
  'reverseProxy/addRoute',
  async ({ reverseProxyId, ...data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await ReverseProxyService.addRoute(reverseProxyId, data)

      await dispatch(getRoutes(reverseProxyId))
      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const editRoute = createAsyncThunk(
  'reverseProxy/editRoute',
  async ({ reverseProxyId, ...data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await ReverseProxyService.editRoute(reverseProxyId, data)

      await dispatch(getRoutes(reverseProxyId))

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const deleteRoute = createAsyncThunk(
  'reverseProxy/deleteRoute',
  async ({ reverseProxyId, routeId }, { rejectWithValue, dispatch }) => {
    try {
      const response = await ReverseProxyService.deleteRoute({
        reverseProxyId,
        routeId,
      })

      await dispatch(getRoutes(reverseProxyId))

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const deleteService = createAsyncThunk(
  'reverseProxy/deleteService',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await ReverseProxyService.deleteService(data)

      await dispatch(getServices(data?.reverseProxyId))
      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const editService = createAsyncThunk(
  'reverseProxy/editService',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await ReverseProxyService.editService(data)

      await dispatch(getServices(data?.reverseProxyId))
      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const createService = createAsyncThunk(
  'reverseProxy/createService',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await ReverseProxyService.createService(data)

      await dispatch(getServices(data?.reverseProxyId))
      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const getServices = createAsyncThunk(
  'reverseProxy/getServices',
  async (reverseProxyId, { rejectWithValue }) => {
    try {
      return await ReverseProxyService.getServices(reverseProxyId)
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const resetProxyReverseDns = createAsyncThunk(
  'reverseProxy/resetProxyReverseDns',
  async ({ reverseProxyId }, { rejectWithValue }) => {
    try {
      const response = await ReverseProxyService.resetReverseProxyDnsRecords(
        reverseProxyId
      )

      return response
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Algo deu errado')
    }
  }
)

export const reverseProxySlice = createSlice({
  name: 'reverseProxy',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getReverseProxyList.pending, state => {
      state.isLoadingReverseProxyList = true
    })
    builder.addCase(getReverseProxyList.fulfilled, (state, action) => {
      state.isLoadingReverseProxyList = false
      state.reverseProxyList = action.payload
    })
    builder.addCase(getReverseProxyList.rejected, state => {
      state.isLoadingReverseProxyList = false
    })
    builder.addCase(deleteReverseProxy.pending, state => {
      state.isLoadingDeleteReverseProxy = true
    })
    builder.addCase(deleteReverseProxy.fulfilled, state => {
      state.isLoadingDeleteReverseProxy = false
      openSuccessNotification({
        key: 'deleteReverseProxy',
        message: i18n.t('message.delete.reverseproxy.success'),
      })
    })
    builder.addCase(deleteReverseProxy.rejected, state => {
      state.isLoadingDeleteReverseProxy = false
      openErrorNotification({
        key: 'deleteReverseProxy',
        message: i18n.t('message.default.error'),
      })
    })
    builder.addCase(getListVps.pending, state => {
      state.isLoadingVps = true
    })
    builder.addCase(getListVps.fulfilled, (state, action) => {
      state.isLoadingVps = false
      state.vps = action.payload?.list
    })
    builder.addCase(getListVps.rejected, state => {
      state.isLoadingVps = false
    })
    builder.addCase(getRoutes.pending, state => {
      state.isLoadingRoutes = true
    })
    builder.addCase(getRoutes.fulfilled, (state, action) => {
      state.isLoadingRoutes = false
      state.routes = action.payload
    })
    builder.addCase(getRoutes.rejected, state => {
      state.isLoadingRoutes = false
    })
    builder.addCase(getServices.fulfilled, (state, action) => {
      state.services = action.payload
    })
    builder.addCase(resetProxyReverseDns.pending, state => {
      state.isLoadingResetProxyReverseDns = true
    })
    builder.addCase(resetProxyReverseDns.rejected, state => {
      state.isLoadingResetProxyReverseDns = false
    })
    builder.addCase(resetProxyReverseDns.fulfilled, state => {
      state.isLoadingResetProxyReverseDns = false
      openSuccessNotification({
        key: 'resetDns',
        message: i18n.t('message.reset.proxyreverse.dns.success'),
      })
    })
    builder.addCase(getReverseProxy.pending, state => {
      state.isLoadingReverseProxy = true
    })
    builder.addCase(getReverseProxy.fulfilled, (state, action) => {
      state.isLoadingReverseProxy = false
      state.reverseProxy = action.payload
    })
    builder.addCase(getReverseProxy.rejected, state => {
      state.isLoadingReverseProxy = false
    })
    builder.addCase(updateReverseProxy.pending, state => {
      state.isLoadingEditProxy = true
    })
    builder.addCase(updateReverseProxy.fulfilled, state => {
      state.isLoadingEditProxy = false
      openSuccessNotification({
        key: 'updateReverseProxy',
        message: i18n.t('message.update.reverseproxy.success'),
      })
    })
    builder.addCase(updateReverseProxy.rejected, state => {
      state.isLoadingEditProxy = false
      openErrorNotification({
        key: 'updateReverseProxy',
        message: i18n.t('message.default.error'),
      })
    })

    builder.addCase(createReverseProxy.fulfilled, () => {
      openSuccessNotification({
        key: 'createReverseProxy',
        message: i18n.t('message.create.reverseproxy.success'),
      })
    })
    builder.addCase(createReverseProxy.rejected, () => {
      openErrorNotification({
        key: 'createReverseProxy',
        message: i18n.t('message.default.error'),
      })
    })
    builder.addCase(addRoute.pending, state => {
      state.isLoadingAddRoute = true
    })
    builder.addCase(addRoute.fulfilled, state => {
      state.isLoadingAddRoute = false
      openSuccessNotification({
        key: 'addRoute',
        message: i18n.t('message.create.route.success'),
      })
    })
    builder.addCase(addRoute.rejected, (state, action) => {
      state.isLoadingAddRoute = false
      openErrorNotification({
        key: 'addRoute',
        message: i18n.t(action.payload),
      })
    })
    builder.addCase(editRoute.pending, state => {
      state.isLoadingEditRoute = true
    })
    builder.addCase(editRoute.fulfilled, state => {
      state.isLoadingEditRoute = false
      openSuccessNotification({
        key: 'editRoute',
        message: i18n.t('message.update.route.success'),
      })
    })
    builder.addCase(editRoute.rejected, (state, action) => {
      state.isLoadingEditRoute = false
      openErrorNotification({
        key: 'editRoute',
        message: i18n.t(action.payload),
      })
    })

    builder.addCase(deleteRoute.fulfilled, () => {
      openSuccessNotification({
        key: 'deleteRoute',
        message: i18n.t('message.delete.route.success'),
      })
    })
    builder.addCase(deleteRoute.rejected, () => {
      openErrorNotification({
        key: 'deleteRoute',
        message: i18n.t('message.default.error'),
      })
    })
    builder.addCase(deleteService.fulfilled, () => {
      openSuccessNotification({
        key: 'deleteService',
        message: i18n.t('message.delete.service.success'),
      })
    })
    builder.addCase(deleteService.rejected, () => {
      openErrorNotification({
        key: 'deleteService',
        message: i18n.t('message.default.error'),
      })
    })

    builder.addCase(createService.fulfilled, () => {
      openSuccessNotification({
        key: 'createService',
        message: i18n.t('message.create.service.success'),
      })
    })
    builder.addCase(createService.rejected, (_, action) => {
      openErrorNotification({
        key: 'createService',
        message: i18n.t(action.payload),
      })
    })

    builder.addCase(editService.fulfilled, () => {
      openSuccessNotification({
        key: 'editService',
        message: i18n.t('message.update.service.success'),
      })
    })
    builder.addCase(editService.rejected, (_, action) => {
      openErrorNotification({
        key: 'editService',
        message: i18n.t(action.payload),
      })
    })
  },
})

export default reverseProxySlice.reducer
